import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import FehlerFang from '@/components/FehlerFang'
import '@/index.css'
import { applySavedTheme } from '@/theme'

applySavedTheme()

ReactDOM.createRoot(document.getElementById('root')).render(
    <FehlerFang><App /></FehlerFang>
) 